
<app-drag-handle />
  
<div 
  #makePaymentRef
  class="make-payment__container"
>
  <header>
    <h2 class="ci-heading-h6-semibold">
      {{ 'Realizar el pago' | translate }}
    </h2>
  </header>

  <!-- <iframe id="iframeId" [src]="urlIframe" frameborder="0" sandbox="allow-same-origin allow-scripts allow-forms allow-modals allow-presentation" style="width: 100%; min-height: 60vh;"></iframe> -->

  
  <main>
    @if (userLoggedIn) {
      <app-logged-payment-card />
    } @else {
      <app-sign-payment-card />
    }
  </main>
  
  <footer class="make-playment__footer">
    <p class="ci-footer-regular">
      {{ 'Todos los trayectos que realices en el día se cargarán al final de la jornada mediante MPASS' | translate }}
    </p>
  </footer>

</div>